import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import '../login/login.scss'
import logo from 'src/assets/images/1journey.png'
import art from 'src/assets/images/readingbook.png'

/* --- inline icons --- */
const MailIcon = () => (
  <svg
    className="jl__lead"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2.5" y="4.5" width="19" height="15" rx="3" />
    <path d="m3.5 6.5 8.5 6 8.5-6" />
  </svg>
)
const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()

    const trimmedEmail = email.trim()
    if (!trimmedEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      const validationMessage = !trimmedEmail ? 'Email is required' : 'Please enter a valid email'
      toast.error(validationMessage, {
        autoClose: 5000,
        style: { background: 'lightcoral', color: 'white' },
      })
      setError(validationMessage)
      return
    }

    setIsLoading(true)

    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL_API}/Account/Forget-Password-Email`, {
        email: trimmedEmail,
      })

      toast.success('Password reset email sent', {
        autoClose: 5000,
        style: { background: 'lightgreen', color: 'black' },
      })
    } catch (err) {
      toast.error(err?.response?.data || 'Something went wrong. Please try again.', {
        autoClose: 5000,
        style: { background: 'lightcoral', color: 'white' },
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleInputChange = (e) => {
    const value = e.target.value
    setEmail(value)
    setError(value.trim() ? '' : 'Email is required')
  }

  return (
    <div className="jl">
      <ToastContainer />
      <div className="jl__shell">
        {/* ---------- Brand / hero ---------- */}
        <aside className="jl__hero jl__hero--art">
          <div className="jl__aurora" aria-hidden="true">
            <span className="jl__orb jl__orb--a" />
            <span className="jl__orb jl__orb--b" />
            <span className="jl__orb jl__orb--c" />
            <span className="jl__beam" />
            <span className="jl__grid" />
          </div>

          <div className="jl__art">
            <span className="jl__art-glow" aria-hidden="true" />
            <img src={art} alt="A student reading" className="jl__art-img" />
            <div className="jl__art-tag">
              <span>1Journey</span>
              <strong>Stay with us</strong>
            </div>
          </div>
        </aside>

        {/* ---------- Form ---------- */}
        <main className="jl__panel">
          <div className="jl__card">
            <img src={logo} alt="1Journey" className="jl__card-logo" />
            <span className="jl__eyebrow">Reset password</span>
            <h2 className="jl__title">Forgot your password?</h2>
            <p className="jl__sub">Enter your email and we&rsquo;ll send you a reset link.</p>

            <form className="jl__form" onSubmit={handleSubmit} noValidate>
              <div className="jl__field">
                <label htmlFor="fp-email">Email</label>
                <div className="jl__control">
                  <MailIcon />
                  <input
                    id="fp-email"
                    type="email"
                    placeholder="you@email.com"
                    autoComplete="username"
                    value={email}
                    onChange={handleInputChange}
                  />
                </div>
                {error && <span className="jl__err">{error}</span>}
              </div>

              <button type="submit" className="jl__btn" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <span className="jl__spinner" aria-hidden="true" /> Sending&hellip;
                  </>
                ) : (
                  <>
                    Send reset link <ArrowIcon />
                  </>
                )}
              </button>
            </form>

            <p className="jl__foot">
              Remember it? <Link to="/login">Back to log in</Link>
            </p>
          </div>
        </main>
      </div>
    </div>
  )
}

export default ForgotPassword
